import { useState } from 'react';
import ThemeSettings from '../commun/ThemeSettings';
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';
import Footer from '../commun/Footer';
import { useProperty } from '../../PropertyContext';

const NewUser = () => {
  const { selectedProperty } = useProperty();

   const [formData, setFormData] = useState({
    firstName: '',
    middleName: '',
    lastName: '',
    city: '',
    state: '',
    country: '',
    pinCode: '',
    mobileNumber: '',
    telephoneNumber: '',
    extension: '',
    dob: '',
    gender: '',
    email: '',
    password: '',
    confirmPassword: '',
    department: '',
    address: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedProperty || !selectedProperty.PropertyID) {
      alert("Please select a property before submitting.");
      return;
    }

    const allUsers = JSON.parse(localStorage.getItem('users')) || {};
    const propertyUsers = allUsers[selectedProperty.PropeortyID] || [];

    propertyUsers.push(formData);
    allUsers[selectedProperty.PropertyID] = propertyUsers;

    localStorage.setItem('users', JSON.stringify(allUsers));
    alert("User registered successfully!");
  };



  return (
    <>
      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <Hearder />
             <div className="container">
          <div className="page-inner">
            
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="card-title">User Details</div>
                  </div>
                  <div className="card-body">
                       <form onSubmit={handleSubmit}>
                       {/* <!-- Row 1: First, Middle, Last Name --> */}
                       <div className="row">
                         <div className="col-md-4">
                           <div className="input-block mb-3">
                             <label className="col-form-label">Contact Person First Name</label>
                             <input type="text" className="form-control" placeholder="Enter First Name" name="firstName" value={formData.firstName} onChange={handleChange} required />
                           </div>
                         </div>
                         <div className="col-md-4">
                           <div className="input-block mb-3">
                             <label className="col-form-label">Middle Name</label>
                             <input type="text" className="form-control" placeholder="Enter Middle Name" name='middleName' value={formData.middleName} onChange={handleChange} />
                           </div>
                         </div>
                         <div className="col-md-4">
                           <div className="input-block mb-3">
                             <label className="col-form-label">Last Name</label>
                             <input type="text" className="form-control" placeholder="Enter Last Name" name='lastName' value={formData.lastName} onChange={handleChange} />
                           </div>
                         </div>
                       </div>

                       {/* <!-- Row 2: City, State, Country --> */}
                       <div className="row">
                         <div className="col-md-4">
                           <div className="input-block mb-3">
                             <label className="col-form-label">City</label>
                             <input type="text" className="form-control" placeholder="Enter City" name='city' value={formData.city} onChange={handleChange} />
                           </div>
                         </div>
                         <div className="col-md-4">
                           <div className="input-block mb-3">
                             <label className="col-form-label">State</label>
                             <input type="text" className="form-control" placeholder="Enter State" name='state' value={formData.state} onChange={handleChange} />
                           </div>
                         </div>
                         <div className="col-md-4">
                           <div className="input-block mb-3">
                             <label className="col-form-label">Country</label>
                             <input type="text" className="form-control" placeholder="Enter Country" name='country' value={formData.country} onChange={handleChange} />
                           </div>
                         </div>
                       </div>

                       {/* <!-- Row 3: Pin Code, Mobile Number, Telephone Number --> */}
                       <div className="row">
                         <div className="col-md-4">
                           <div className="input-block mb-3">
                             <label className="col-form-label">Pin Code</label>
                             <input type="text" className="form-control" placeholder="Enter Pin Code" name='pinCode' value={formData.pinCode} onChange={handleChange} />
                           </div>
                         </div>
                         <div className="col-md-4">
                           <div className="input-block mb-3">
                             <label className="col-form-label">Mobile Number</label>
                             <input type="number" className="form-control" placeholder="Enter Mobile Number" name='mobileNumber' value={formData.mobileNumber} onChange={handleChange} />
                           </div>
                         </div>
                         <div className="col-md-4">
                           <div className="input-block mb-3">
                             <label className="col-form-label">Telephone Number</label>
                             <input type="number" className="form-control" placeholder="Enter Telephone Number" name='telephoneNumber' value={formData.telephoneNumber} onChange={handleChange} />
                           </div>
                         </div>
                       </div>

                       {/* <!-- Row 4: Extension, DOB, Gender --> */}
                       <div className="row">
                         <div className="col-md-4">
                           <div className="input-block mb-3">
                             <label className="col-form-label">Extension</label>
                             <input type="text" className="form-control" placeholder="Enter Extension" name='extension' value={formData.extension} onChange={handleChange}/>
                           </div>
                         </div>
                         <div className="col-md-4">
                           <div className="input-block mb-3">
                             <label className="col-form-label">Date Of Birth</label>
                             <input type="date" className="form-control" name='dob' value={formData.dob} onChange={handleChange} />
                           </div>
                         </div>
                         <div className="col-md-4">
                           <div className="input-block mb-3">
                             <label className="col-form-label">Gender</label>
                             <select className="form-control form-select" name='gender' value={formData.gender} onChange={handleChange}>
                               <option>Select Gender</option> 
                               <option>Male</option>
                               <option>Female</option>
                               <option>Other</option>
                             </select>
                           </div>
                         </div>
                       </div>

                       {/* <!-- Row 5: Email, Password, Confirm Password --> */}
                       <div className="row">
                         <div className="col-md-4">
                           <div className="input-block mb-3">
                             <label className="col-form-label">Email</label>
                             <input type="email" className="form-control" placeholder="Enter Email" name='email' value={formData.email} onChange={handleChange} />
                           </div>
                         </div>
                         <div className="col-md-4">
                           <div className="input-block mb-3">
                             <label className="col-form-label">Password</label>
                             <input type="password" className="form-control" placeholder="Enter Password" name='password' value={formData.password} onChange={handleChange} />
                           </div>
                         </div>
                         <div className="col-md-4">
                           <div className="input-block mb-3">
                             <label className="col-form-label">Confirm Password</label>
                             <input type="password" className="form-control" placeholder="Confirm Password" name='confirmPassword' value={formData.confirmPassword} onChange={handleChange} />
                           </div>
                         </div>
                       </div>

                       {/* <!-- Row 6: Department, Address (full width) --> */}
                       <div className="row">
                         <div className="col-md-4">
                           <div className="input-block mb-3">
                             <label className="col-form-label">Department</label>
                             <select className="form-control form-select" name='department' value={formData.department} onChange={handleChange}>
                               <option>Sales & Marketing</option>
                               <option>IT</option>
                               <option>HR</option>
                               <option>Finance</option>
                             </select>
                           </div>
                         </div>
                         <div className="col-md-8">
                           <div className="input-block mb-3">
                             <label className="col-form-label">Address</label>
                             <textarea rows="2" className="form-control" placeholder="Enter Address" name='address' value={formData.address} onChange={handleChange}></textarea>
                           </div>
                         </div>
                       </div>
                       <div className="card-action text-end">
                    <button type="submit" className="btn btn-primary">Register Now</button>
                  </div>
                     </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          <Footer />
        </div>
        <ThemeSettings />
      </div>
    </>
  );
};

export default NewUser;